import styles from '../TrainMachine.module.css'

function RecordingControls({
    isRecording,
    recognizer,
    capturedSamples,
    canvasRef,
    micError,
    onStart,
    onStop,
}) {
    return (
        <div className={styles.audioControlButtons}>
            <div style={{ marginBottom: '15px' }}>
                <p
                    style={{
                        fontWeight: 'bold',
                        color: isRecording
                            ? '#3e74e0'
                            : 'inherit',
                    }}
                >
                    <span >
                        {capturedSamples.length}
                    </span>
                    /20 samples
                </p>
                {isRecording && (
                    <canvas
                        ref={canvasRef}
                        width={250}
                        height={80}
                        style={{
                            width: '100%',
                            background: '#0e005a',
                            borderRadius: '10px',
                            
                        }}
                    />
                )}
                <div
                    style={{
                        width: '100%',
                        height: '10px',
                        backgroundColor: '#eee',
                        borderRadius: '5px',
                        marginTop: '10px',
                    }}
                >
                    <div
                        style={{
                            width: `${Math.min(100, (capturedSamples.length / 20) * 100)}%`,
                            height: '100%',
                            backgroundColor:
                                capturedSamples.length >= 20
                                    ? '#4caf50'
                                    : '#3e74e0',
                            borderRadius: '5px',
                            transition: 'width 0.5s ease',
                        }}
                    />
                </div>
            </div>

            <button
                onClick={isRecording ? onStop : onStart}
                className={styles.capturePhotoBtn}
                style={{
                    opacity: recognizer ? 1 : 0.5,
                    backgroundColor: isRecording
                        ? '#f44336'
                        : '#3e74e0',
                }}
                disabled={!recognizer}
            >
                {isRecording
                    ? 'Stop Recording'
                    : 'Start Recording'}
            </button>
            {micError && (
                <div className={styles.audioMicError}>
                    {micError}
                </div>
            )}
        </div>
    )
}

export default RecordingControls
